import { AlpineComponent } from 'alpinejs';

const Table = (): AlpineComponent => ({
  scrollable: false,
  scrollAmount: 100,
  onResize() {
    this.checkScroll();
  },
  checkScroll() {
    if (
      this.$refs.tableContainer.scrollWidth >
      this.$refs.tableContainer.clientWidth
    ) {
      this.$refs.tableContainer.classList.add('scrollable');
    } else {
      this.$refs.tableContainer.classList.remove('scrollable');
    }

    if (this.$refs.tableContainer.scrollLeft === 0) {
      this.$refs.prev.disabled = true;
    } else {
      this.$refs.prev.disabled = false;
    }

    if (
      this.$refs.tableContainer.scrollLeft +
        this.$refs.tableContainer.clientWidth >=
      this.$refs.tableContainer.scrollWidth
    ) {
      this.$refs.next.disabled = true;
    } else {
      this.$refs.next.disabled = false;
    }
  },
  init() {
    this.checkScroll();
    this.$refs.tableContainer.addEventListener(
      'scroll',
      this.checkScroll.bind(this)
    );

    this.$refs.prev.addEventListener('click', () => {
      this.$refs.tableContainer.scrollBy({
        left: -this.scrollAmount,
        behavior: 'smooth'
      });
    });

    this.$refs.next.addEventListener('click', () => {
      this.$refs.tableContainer.scrollBy({
        left: this.scrollAmount,
        behavior: 'smooth'
      });
    });
  }
});

export default Table;
